import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsCrmAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels_crm', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label_crm';
  }
}

export default new LabelsCrmAPI();
